import React from "react";
import { observer } from "mobx-react";

// Translations
import translate from "../Translate.js";
import {
  checkValidity,
  closeDrawer,
  getURLSegment,
  confirm
} from "../../helpers/helpers.js";


const EditUsers = observer(
  class EditUsers extends React.Component {
    constructor() {
      super();

      this.state = {
        firstName: null,
        lastName: null,
        email: null,
        username: null,
      };
    }

    componentDidMount() {
      const { EnrollmentStore } = this.props.store;
      const userSid = getURLSegment(this, 3);

      EnrollmentStore.proctorUser = null;

      EnrollmentStore.listProctorUsers(userSid);
    }

    componentDidUpdate() {
      const { firstName, lastName, email, username } = this.state;
      const proctorUser = this.props.store.EnrollmentStore.proctorUser;

      // console.log(JSON.stringify(proctorUser))

      if (proctorUser && (!firstName || !lastName || !email || !username)) {

        this.setState({
          firstName: proctorUser.firstName,
          lastName: proctorUser.lastName,
          email: proctorUser.email,
          username: this.state.email
        });
      }
    }

    /**
     * Submit the settings form.
     *
     * @function handleSubmit
     */
    handleSubmit = async () => {
      const { EnrollmentStore, SessionStore } = this.props.store;
      const { firstName, lastName, email, username } = this.state;

      const data = {
        firstName,
        lastName,
        email,
        username
      };

      const callback = () => {
        closeDrawer(null, this.props.parent, "/users");
        SessionStore.showToaster(this.props.translation.user_updated, "success");
      };

      EnrollmentStore.updateProctorUser(data, callback);
    };

    /**
     * Store input values.
     *
     * @function handleInput
     * @param {event} e
     */
    handleInput = (e) => {
      const { name, value } = e.target;

      if(name === 'email') {
        this.setState({
          email: value,
          username: value
        })
      } else {
        this.setState({
          [name]: value,
        });
      }
    };

    /**
     * Delete Proctor User.
     *
     * @function handleDelete
     * 
     */
    handleDelete = () => {
      const { EnrollmentStore, SessionStore } = this.props.store;
      const { translation } = this.props;
      const msg = translation.delete_confirm;

      const callback = () => {
        closeDrawer(null, this.props.parent, "/users");
        SessionStore.showToaster(this.props.translation.user_deleted, "success");
      };
      confirm(msg, () => EnrollmentStore.deleteProctorUser(callback));
    }

    render() {
      const { translation } = this.props;
      const { EnrollmentStore } = this.props.store;
      const proctorUser = EnrollmentStore.proctorUser;

      if (proctorUser) {
        return (
          <div className="drawer__content">
            <header className="drawer__header">
              <div className="wrap">
                <h1 className="drawer__title">{translation.heading}</h1>
              </div>
            </header>

            <div className="wrap">
              <form className="form panel panel__body" onSubmit={(e) => checkValidity(e, this.handleSubmit)}>
                <fieldset>
                  <ul className="fields">
                    <li className="field--half">
                      <label
                        className="form__lbl required"
                        htmlFor="form-text1"
                      >
                        {translation.first_name}
                      </label>

                      <input
                        type="text"
                        id="form-text1"
                        name="firstName"
                        defaultValue={proctorUser.firstName}
                        required
                        aria-required="true"
                        data-errormsg="Error message with instructions to correct"
                        onChange={this.handleInput}
                      />
                    </li>
                    <li className="field--half">
                      <label
                        className="form__lbl required"
                        htmlFor="form-text2"
                      >
                        {translation.last_name}
                      </label>

                      <input
                        type="text"
                        id="form-text2"
                        name="lastName"
                        defaultValue={proctorUser.lastName}
                        required
                        aria-required="true"
                        data-errormsg="Error message with instructions to correct"
                        onChange={this.handleInput}
                      />
                    </li>
                    <li>
                      <label className="form__lbl" htmlFor="form-text3">
                          {translation.email}
                        </label>

                        <input
                          type="text"
                          id="form-text3"
                          name="email"
                          defaultValue={proctorUser.email}
                          onChange={this.handleInput}
                        />
                    </li>
                  </ul>
                </fieldset>

                <div className="panel__actions actions">
                  <button className="btn btn--negative"
                    type="button"
                    onClick={this.handleDelete}>
                    {translation.delete}
                  </button>
                  <button className="btn" type="submit">
                    {translation.save}
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
      }
      return null;
    }
  }
);

export default translate("EditUsers")(EditUsers);



// WEBPACK FOOTER //
// ./src/app/components/Users/EditUsers.js